import { AfterContentInit, AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BasicUser } from 'src/app/domain/models/User';
import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { LoadFilters, MasterLoad, MyLoadRequest, Pallet } from 'src/app/domain/models/Pallet';

import { transportTypes, TransportTypeUtils } from 'src/app/ui/util/transportType.Utils';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { AuthApiService } from 'src/app/application/service/AuthService';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { Profile, ProfileContactInfo } from 'src/app/domain/models/Profile';
import { Router } from '@angular/router';
import { Routes } from 'src/app/infrastructure/routes';
import { Table } from 'primeng/table';
import { FilterLoadsUtils, MyLoadsFilterProgram } from 'src/app/ui/util/custom-filters-my-loads';
import { BasicSelect } from 'src/app/ui/util/select-utils';
import { PalletUtils } from 'src/app/ui/util/pallets-utils';
import { excelUtils } from 'src/app/ui/util/excel-utils';


@Component({
  selector: 'app-user-load-master-orders-program',
  templateUrl: './user-load-master-orders-program.component.html',
  styleUrls: ['./user-load-master-orders-program.component.css'],

})
export class UserLoadMasterOrdersProgramComponent implements OnInit, AfterContentInit {

  profile: ProfileContactInfo | undefined
  companyName: string = ""
  orders: LoadOrderListItem[] = []
  shipments: LoadOrderListItem[] = []
  searchTerm: string = '';

  masterLoads: MasterLoad[] = []

  loading: boolean = false
  year: number = new Date().getFullYear()

  requestLoad: MyLoadRequest = {
    years: [],
    isClosedSale: true,
    clients: [],
    containers: [],
    programs: [],
    ships: [],
    species: [],
    varieties: [],
    transportTypes: [],
    weeks: []
  }

  totalCount = 0;
  pageSize = 100;

  filteredRegisters: MasterLoad[] = []
  containerFilter: SelectItem[] = []
  weekFilter: SelectItem[] = []
  importerFilter: SelectItem[] = []
  specieFilter: SelectItem[] = []
  varietyFilter: SelectItem[] = []
  shipFilter: SelectItem[] = []
  profileBasic: BasicUser | undefined

  numberProgramsFilter: SelectItem[] = []

  programFilter: MyLoadsFilterProgram | undefined;
  selectedCompanies: Profile[] = [];
  selectedPrograms: number[] = [];
  selectedSpecies: string[] = []
  selectedContainers: string[] = []
  selectedVarieties: string[] = []
  selectedShip: string[] = []
  selectedWeeks: number[] = []
  selectedTransportTypes: number[] = [];
  transportSelect: BasicSelect[] = transportTypes;
  lang: string = 'en';
  yearSelect: number[] = []

  years: SelectItem[] = []

  profileUser: BasicUser | undefined


  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  constructor(
    private _router: Router,
    private _messageService: MessageService,
    private _palletService: PalletGateway,
    public translateService: TranslateService,
    private _authService: AuthGateway,
    private _profileService: ProfileService

  ) {
    this.getYears()
    if (this._router.getCurrentNavigation()?.extras?.state?.['year'] !== undefined) {
      this.year = this._router.getCurrentNavigation()?.extras.state?.['year'];
    }
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    let breadcrumbMenuItemLabel1 = 'Master view'
    let breadcrumbHomeMenuItemLabel = 'Reports'

    if(this.profileUser) {
      switch(this.profileUser.lang) {
        case 'en':
          breadcrumbMenuItemLabel1 = 'Master view'
          breadcrumbHomeMenuItemLabel = 'Reports'
          break
        case 'es':
          breadcrumbMenuItemLabel1 = 'Vista Master'
          breadcrumbHomeMenuItemLabel = 'Reportes'
          break
      }
    }

    this.configFilter()

    this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
    this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrdersProgram };
    this.getLoadMasterFilters()
    this.companyName = this._authService.getUser()?.companyName ?? ""
    this._profileService.getContactInfo().subscribe({
      next: (v) => {
        this.profile =  v
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
      },
    })

    this.profileBasic = this._authService.getUser()
    if(this.profileBasic){
      this.lang = this.profileBasic.lang;
    }

  }

  getYears() {
    let current = new Date()
    let currentYear = current.getFullYear()

    for(let i = 2023; i <= currentYear; i++) {
      this.years.push({label:i.toString(), value: i})
    }
  }



  @ViewChild('loadMasterTable') dt: any;
  ngAfterContentInit(): void{
  }

  // Funcion para setear variables filtro
  configFilter()
  {
    this.programFilter = FilterLoadsUtils.getFilterProgramConfig()

    if(this.programFilter)
    {
      if(this.programFilter.profileName)
      {
        this.selectedCompanies = [];
      }

      if(this.programFilter.programId)
      {
        this.selectedPrograms = [];
        this.selectedPrograms.push(this.programFilter.programId)
      }

      if(this.programFilter.transportType != undefined)
      {
        this.selectedTransportTypes = [];
        this.selectedTransportTypes.push(this.programFilter.transportType);
      }

      if(this.programFilter.year)
      {
        this.yearSelect.push(this.programFilter.year);
      }


    }

    this.updateSelectedYear()
    this.setUpFilter()
    this.getLoadMasterFilters()

  }

  changeFilter()
  {
    this.setUpFilter()
    this.loadMaster()
    this.getLoadMasterFilters()
  }


  setUpFilter(pageNumber: number = 1, pageSize: number = 100)
  {

    this.requestLoad.years = this.yearSelect;
    this.requestLoad.pageNumber = pageNumber;
    this.requestLoad.pageSize = pageSize;
    this.requestLoad.programs = this.selectedPrograms;
    this.requestLoad.transportTypes = this.selectedTransportTypes.map(x => x);
    this.requestLoad.ships = this.selectedShip.map(x => x);
    this.requestLoad.species = this.selectedSpecies.map(x => x);
    this.requestLoad.clients = this.selectedCompanies.map(x => x.id);
    this.requestLoad.containers = this.selectedContainers.map(x => x);

  }

  filterLoads() {
    if (!this.searchTerm.trim()) {
      // Si el término de búsqueda está vacío, mostrar todos los pedidos
      this.filteredRegisters = this.masterLoads;
    } else {
      // Filtrar los pedidos basados en el término de búsqueda
      this.filteredRegisters = this.masterLoads.filter(product =>
        product.pallet.importOrderDetail.importOrder.sequence?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetailId.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.id.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.palletNumber.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        this.getTransportName(product.pallet.importOrderDetail.importOrder.transportType).toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportSpecies?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportVariety?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.producer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.speciesSize?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportHarvestDate?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportQualityControlDate?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportPackaging?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportPalletType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportTag?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportBagType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportBoxSize?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportNetWeight?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportFridgeStorage?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportBoxesPerPallet?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportMark?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportContainerNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportGrade?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportTemptale?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportOriginCountry?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportCertificate1?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportCertificate2?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportCertificate3?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.excelImportLoadWeek?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.bl?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.booking?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.containerNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.exportOffer?.exporter?.companyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.exportOffer?.exporter?.contactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.importOrder?.importer?.companyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.pallet.importOrderDetail?.importOrder?.importer?.contactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.consigneeCompanyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.consigneeContactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.notifierCompanyName?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.notifierContactEmail?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.deliveryInstructions?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.containerCbm?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.containerTemperature?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.placeReceipt?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.departurePort?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.destinationPort?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.departureAirport?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.destinationAirport?.name?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.week?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.placeDelivery?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.ship?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.voyageNumber?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.typeMovement?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.oceanFreight?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.inland?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.localCharges?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.customs?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.surcharge?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.otherCosts?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.freightPayableAt?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.placeIssue?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.delivery?.excessValueDeclaration?.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    }
  }

  downloadExcelMaster()
  {
    this.setUpFilter();
    this.loading = true;
    this._palletService.downloadMyMasterLoad(this.requestLoad).subscribe({
      next: (resultBlob) => {
          const contentDisposition = resultBlob.headers.get('Content-Disposition');
          let nombreArchivo = 'MASTER';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);

            if (match && match[1]) {
                nombreArchivo = match[1];
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }else{
          excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }

        this.loading = false;
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
        summary: this.translateService.instant('MessageService.Summary.FailedAction'),
        detail:  this.translateService.instant('MessageService.Excel.FailedDownload') })
        this.loading = false;
      }
    })
  }

  translateTextExcel(text: string) {
    return this.translateService.instant(`UserPages.UserLoadMasterOrders.MainTable.${text}`);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';``
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    let date = new Date()
    var FileSaver = require('file-saver');
    FileSaver.saveAs(data, fileName + '-' + date.getDate()  + '-' + (date.getMonth() + 1) + '-' +date.getFullYear() + EXCEL_EXTENSION);
  }


  loadMaster(pageNumber: number = 1, pageSize: number = 100){
    this.loading = true;

    let config = FilterLoadsUtils.getFilterProgramConfig()

    if(config){
      if(config.year){
        this.year = config.year
      }
    }
    this.setUpFilter(pageNumber, pageSize);
    this._palletService.getUserMasterLoadPaged(this.requestLoad).subscribe({
      next: (v) => {
        this.loading = false;
        this.masterLoads = v.items
        this.filteredRegisters = v.items
        this.totalCount = v.totalCount
        // this.configFilter()
      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Error al consultar los registros.' });
      },
    })
  }

  getLoadMasterFilters()
  {
    this.loading = false;

    this._palletService.getLoadsFilter(this.requestLoad).subscribe({
      next: (v) => {
          this.buildFilters(v);
      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los Master Loads.' });
      }

    })
  }

  loadMasterPage(event: any)
  {
    const pageNumber = Math.floor(event.first / event.rows) + 1;
    const pageSize = event.rows;

    this.loadMaster(pageNumber, pageSize);
  }

  buildFilters(loadFilters: LoadFilters )
  {
    this.containerFilter = []
    this.numberProgramsFilter = []
    this.weekFilter = []
    this.specieFilter = []
    this.shipFilter = []
    this.varietyFilter = []
    this.importerFilter = []

    if(loadFilters.containers.length > 0)
    {
      loadFilters.containers.map(item => {
        this.containerFilter.push({ label: item, value: item })
      })
    }


    loadFilters.weeks.map(item => {
      this.weekFilter.push({label :item.toString(), value: item} )
    })



    loadFilters.clients.map(item => {
      this.importerFilter.push({ label: item.companyName, value: item.id })
    })



    loadFilters.species.map(item => {
      this.specieFilter.push({ label: item, value: item })
    })



    loadFilters.varieties.map(item => {
      this.varietyFilter.push({ label: item, value: item })
    })



    loadFilters.ships.map(item => {
      this.shipFilter.push({ label: item, value: item })
    })


    loadFilters.programs.map(item => {
        this.numberProgramsFilter.push({ label: item.toString(), value: item })
      })

  }

  getTransportName(transportType: number)
  {
    return TransportTypeUtils.getTransportName(this.translateService.currentLang, transportType);
  }

  goToLoadsPage(): void {
    // this.clearFilters()
    this._router.navigate([Routes.userLoadOrdersProgram]);
  }

  clearFilters() {
    sessionStorage.removeItem("dt-masterload-session")
  }

  updateSelectedYear()
  {
    this.yearSelect = []
    this.yearSelect.push(this.year);
  }

  removeConfigFilter()
  {
    FilterLoadsUtils.removeFilterProgramConfig()
  }

  searchLoadContainers(event: any)
  {
    this.removeConfigFilter()
    if(event.value.length > 0)
    {
      this.year = event.value[0]
      this.loadMaster()
    }else{
      this.masterLoads = []
      this.filteredRegisters = []
      this.yearSelect = []
    }
  }

  getBoxesPerPallet(pallet:Pallet)
  {
    return PalletUtils.calculateBoxesPerPallet(pallet);
  }

}
